import { createBrowserRouter } from 'react-router-dom';
import { SuitabilityWizard } from 'src/suitability';
import { NotFound } from 'components/not-found';

export const router = createBrowserRouter([
  {
    // Mirrors the legacy embed URL: wio.front embeds this path in the iframe,
    // passing the wio.api clientId.
    path: '/embed/suitability-test/:clientId',
    element: <SuitabilityWizard />,
  },
  { path: '*', element: <NotFound /> },
]);
